import useUserAction from "../../../hooks/user/useUserAction";
import useUserData from "../../../hooks/user/useUserData";
import * as yup from "yup";
import { CUSTOMERS } from "../../customers/locales/namespaces";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { API } from "../../../helpers/constants";
import { logoutUnauthorizedUser } from "../../../helpers/errorHandling";

const useCheckEmail = () => {
  const { userLogout } = useUserAction();
  const { token, isLoggedIn } = useUserData();
  const { t } = useTranslation(CUSTOMERS);
  const validationSchema = yup.object({
    email: yup.string().required(t("Required")).email(t("Enter a valid email")),
  });

  const checkEmail = async (email) => {
    try {
      await validationSchema.validate({ email });

      const response = await axios({
        method: "post",
        data: {
          email,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        url: `${API}/check-email`,
      });
      return response.data;
    } catch (error) {
      if (error.name === "ValidationError") {
        return;
      } else {
        logoutUnauthorizedUser(error, isLoggedIn, userLogout);
      }
    }
  };

  return {
    checkEmail,
  };
};

export default useCheckEmail;
